module.exports = __webpack_public_path__ + "img/picture_VIP02.4d89cda0.png";